module.exports = __webpack_public_path__ + "img/nexultra-L-75.4bd45c70.jpg";